import styled, { css, keyframes } from "styled-components";

export type AlertType = "error" | "warning" | "info" | "success";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fadeOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-10px); }
`;

interface AlertContainerProps {
  $type: AlertType;
  $dismissible?: boolean;
  $isClosing: boolean;
}

const typeStyles = {
  error: css`
    background-color: var(--red);
    border: 1px solid var(--red);
    color: var(--white);
    svg {
      color: var(--white);
    }
  `,
  warning: css`
    background-color: var(--yellow-500);
    border: 1px solid var(--yellow-400);
    color: var(--black);
    svg {
      color: var(--black);
    }
  `,
  info: css`
    background-color: var(--blue);
    border: 1px solid var(--blue);
    color: var(--white);
    svg {
      color: var(--white);
    }
  `,
  success: css`
    background-color: var(--green);
    border: 1px solid var(--green-2);
    color: var(--white);
    svg {
      color: var(--white);
    }
  `,
};

export const AlertContainer = styled.div<AlertContainerProps>`
  position: fixed;
  width: 500px;
  top: 15px;
  right: 15px;
  padding: 1rem ${({ $dismissible }) => ($dismissible ? "2.5rem" : "1rem")} 1rem
    1rem;
  margin-bottom: 1rem;
  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : fadeIn)} 0.3s
    ease-out;
  animation-fill-mode: forwards;
  align-items: center;
  gap: 0.5rem;
  box-shadow: var(--shadow-500);
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;

  ${({ $type }) => typeStyles[$type]}
`;

export const DismissButton = styled.button`
  position: absolute;
  background: transparent;
  right: 10px;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 1;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`;
